import { color4vehicle, int2color } from '@common/decorators/color';
import { BASE_ROUTE_COLOR } from '@common/constants';
import { Vehicle } from '@common/types';

export const getVehicleRouteColor = (vehicle?: Partial<Pick<Vehicle, 'ID' | 'RouteColor'>>) => {
  return vehicle?.RouteColor ? int2color(vehicle?.RouteColor) : vehicle?.ID ? color4vehicle(vehicle?.ID) : BASE_ROUTE_COLOR;
};
